import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=48cc90fa&scoped=true&"
var script = {}
import style0 from "./Error404.vue?vue&type=style&index=0&id=48cc90fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc90fa",
  null
  
)

export default component.exports